import * as React from 'react';
import { OptionDescription, OptionsCheckbox } from 'owa-options-controls';
import ColoredBulletOption from './ColoredBulletOption';
import { Label } from 'office-ui-fabric-react/lib/Label';
import getStore from '../data/store/store';
import { observer } from 'mobx-react';
import strings from 'owa-strings/owa-options-strings';
import updateChangeNotificationStatusInCurrentState from '../data/mutators/updateChangeNotificationStatusInCurrentState';
var styles = require('./CalendarUpdatesSection.scss');
/**
 *  This renders a list of notification subscription settings for shared calendars.
 */
export default observer(function CalendarUpdatesSection() {
    var _a = getStore(), calendars = _a.calendars, currentState = _a.currentState;
    return (React.createElement("div", { className: styles.calendarUpdatesWrapper },
        React.createElement(Label, { className: styles.sectionTitle }, strings.optionTitle_calendarUpdates),
        React.createElement(OptionDescription, { className: styles.sectionMessage }, strings.options_sharedCalendars_CalendarUpdatesSectionMessage),
        React.createElement("div", { className: styles.sectionCheckboxesMessage }, strings.options_sharedCalendars_CalendarUpdatesUserChoicesSectionMessage),
        getCalendarUpdates(calendars).map(function (sharedCalendar) {
            var checked = currentState[sharedCalendar.folderId] == 1 /* Enabled */;
            var label = sharedCalendar.calendarName;
            return (React.createElement(OptionsCheckbox, { key: sharedCalendar.folderId, checked: checked, onChange: onNotificationSettingChange(sharedCalendar.folderId), label: label, color: sharedCalendar.hexColorString, onRenderLabel: onRenderLabel }));
        })));
});
var getCalendarUpdates = function (calendars) {
    return (calendars &&
        calendars.filter(function (calendar) {
            return calendar.canEnableChangeNotifications;
        }));
};
var onNotificationSettingChange = function (folderId) { return function (ev, checked) {
    updateChangeNotificationStatusInCurrentState(folderId, checked);
}; };
/**
 * Custom renderer for checkbox as a colored bullet needs to be shown
 */
var onRenderLabel = function (props) {
    return (React.createElement(ColoredBulletOption, { color: props.color, label: props.label, iconClassName: styles.coloredBullet }));
};
//# sourceMappingURL=CalendarUpdatesSection.js.map